import classNames from 'classnames';
import React from 'react';

import Icon from '@wetransfer/transfer/component/icon';
import { SILVER_SAND } from '@wetransfer/transfer/constant/colors';
import Browser from '@wetransfer/transfer/modules/concorde-browser/browser';
import I18n from '@wetransfer/transfer/modules/i18n';
import { Button } from '@wetransfer/transfer/oneui/react';

import styles from './Blocked.module.scss';
import { BlockedProps } from './types';

function Blocked({
  title,
  subtitle,
  onClickBackButton,
}: BlockedProps): JSX.Element {
  return (
    <div
      className={classNames(styles.Blocked, Browser.isMobile && styles.mobile)}
    >
      <div className={styles.content}>
        <Icon
          type="ErrorBig"
          className={classNames(styles.errorIcon)}
          color={SILVER_SAND}
        />
        {title && <h2 className={styles.title}>{title}</h2>}
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {Browser.isMobile && (
          <Button
            className={styles.mobileBackButton}
            onClick={onClickBackButton}
            variant="inverted"
          >
            {I18n.t('transfer.download.back_to_transfer')}
          </Button>
        )}
      </div>
      {!Browser.isMobile && (
        <div className={styles.footer}>
          <Icon
            className={styles.backButton}
            onClick={onClickBackButton}
            type="TransferBack"
            label={I18n.t('transfer.download.back_to_transfer')}
          />
          <Button
            className={styles.downloadButton}
            disabled
            small
            variant="primary"
          >
            {I18n.t('transfer.buttons.download')}
          </Button>
        </div>
      )}
    </div>
  );
}

export default Blocked;
